export const SPINNER_PAGE_CONFIG = {
  "08lm4nsW2ratEeO4BHSr": {
    brandName: "Local Helper",
    eyebrow: "Promotional offer",
    title: "Unlock your car cleaning offer",
    mainHeading: "Verify your mobile number and reveal your final offer",
    subtitle:
      "This reward wheel is part of the Local Helper car cleaning offer experience. ਜਦੋਂ ਚੱਕਰ ਰੁਕੇਗਾ, ਤੁਹਾਡਾ ਆਫਰ ਫਾਈਨਲ ਹੋ ਜਾਵੇਗਾ.",
    punjabiLine: "ਥੋੜ੍ਹਾ ਜਿਹਾ ਲੱਕ, ਤੇ ਵੱਡੀ ਬਚਤ.",
    verificationTitle: "Verify mobile number",
    verificationSubtitle: "One quick verification before you spin. ਬਸ ਇਕ ਛੋਟੀ ਜਿਹੀ ਤਸਦੀਕ.",
    termsAndConditions: [
      "* Offer cannot be clubbed with any other promotion or coupon.",
      "* Offer is valid only for car cleaning and one verified mobile number.",
      "* Offer can be redeemed only once per verified mobile number.",
      "* Offer is non-transferable and cannot be exchanged for cash.",
      "* Final eligibility is subject to booking validation at checkout.",
      "* Final discount is applied at checkout as per offer rules.",
      "* By spinning the wheel, you agree to these terms and conditions.",
    ],
    offerDetails: [
      { label: "Reward source", value: "Local Helper" },
      { label: "Offer type", value: "Car cleaning promotion" },
      { label: "Verification", value: "Mobile OTP" },
    ],
  },
};

export const SPINNER_OFFERS_BY_SERVICE = {
  "08lm4nsW2ratEeO4BHSr": [
    {
      id: "car_5",
      title: "5% OFF",
      subtitle: "Welcome spin",
      percentageOff: 5,
      flatOff: null,
    },
    {
      id: "car_10",
      title: "10% OFF",
      subtitle: "Starter savings",
      percentageOff: 10,
      flatOff: null,
    },
    {
      id: "car_30",
      title: "15% OFF",
      subtitle: "Interior shine bonus",
      percentageOff: 15,
      flatOff: null,
    },
    {
      id: "car_60",
      title: "20% OFF",
      subtitle: "Premium wash saver",
      percentageOff: 20,
      flatOff: null,
    },
    {
      id: "car_25",
      title: "25% OFF",
      subtitle: "Extra shine reward",
      percentageOff: 25,
      flatOff: null,
    },
    {
      id: "car_35",
      title: "35% OFF",
      subtitle: "Premium saver spin",
      percentageOff: 35,
      flatOff: null,
    },
    {
      id: "car_50",
      title: "50% OFF",
      subtitle: "Half-price delight",
      percentageOff: 50,
      flatOff: null,
    },
    {
      id: "car_75",
      title: "75% OFF",
      subtitle: "Mega reward drop",
      percentageOff: 75,
      flatOff: null,
    },
    {
      id: "car_100",
      title: "100% OFF",
      subtitle: "Jackpot clean",
      percentageOff: 100,
      flatOff: null,
    },
  ],
};

export const getSpinnerOffersForService = (serviceSlug) => {
  return SPINNER_OFFERS_BY_SERVICE[serviceSlug] ?? SPINNER_OFFERS_BY_SERVICE["08lm4nsW2ratEeO4BHSr"];
};

export const getSpinnerPageConfig = (serviceSlug) => {
  return SPINNER_PAGE_CONFIG[serviceSlug] ?? SPINNER_PAGE_CONFIG["08lm4nsW2ratEeO4BHSr"];
};
